import Moment from 'moment';

import {
	PRODUCT_TYPE_EVO,
	PRODUCT_TYPE_NOVA
} from '../../dashboard/product-filter';

export const REQUIRED_SHIPMENT_DATE_HEADERS = ['Serial Numbers', 'Invoice Date'];

const SHIPMENT_DATE_FORMATS = [
	'M/D/YYYY',
	'MM/DD/YYYY',
	'M/D/YY',
	'MM/DD/YY',
	'YYYY-MM-DD'
];

export const validateShipmentDateHeaders = fields => {
	const csvFields = fields || [];
	return REQUIRED_SHIPMENT_DATE_HEADERS.filter(field => csvFields.indexOf(field) === -1);
};

export const normalizeShipmentSerial = (serialNumber, productType) => {
	const rawSerialNumber = serialNumber === undefined || serialNumber === null
		? ''
		: String(serialNumber).trim();
	const normalizedSerialNumber = rawSerialNumber.split('/').pop().trim();

	return parseInt(productType) === PRODUCT_TYPE_NOVA
		? normalizedSerialNumber.toUpperCase()
		: normalizedSerialNumber;
};

const getSerialProductError = (serialNumber, productType) => {
	if (!serialNumber) {
		return 'Serial number is required.';
	}

	const isNovaSerial = serialNumber.toUpperCase().indexOf('RJ') === 0;

	if (parseInt(productType) === PRODUCT_TYPE_NOVA && !isNovaSerial) {
		return 'Nova serial numbers must start with RJ.';
	}

	if (parseInt(productType) === PRODUCT_TYPE_EVO && isNovaSerial) {
		return 'This appears to be a Nova serial number.';
	}

	return null;
};

const addRowError = (row, message) => {
	if (row.Errors.indexOf(message) === -1) {
		row.Errors.push(message);
	}
};

export const buildShipmentDateRows = (csvRows, productType) => {
	const rows = [];

	(csvRows || []).forEach((csvRow, rowIndex) => {
		const serialsValue = csvRow && csvRow['Serial Numbers'] !== undefined
			? csvRow['Serial Numbers']
			: '';
		const invoiceDateValue = csvRow && csvRow['Invoice Date'] !== undefined
			? csvRow['Invoice Date']
			: '';
		const parsedInvoiceDate = Moment(String(invoiceDateValue).trim(), SHIPMENT_DATE_FORMATS, true);
		const serialValues = String(serialsValue).split(',');

		serialValues.forEach((serialValue, serialIndex) => {
			const serialNumber = normalizeShipmentSerial(serialValue, productType);
			const row = {
				id: `${rowIndex}-${serialIndex}`,
				SerialNumber: serialNumber,
				InvoiceDate: parsedInvoiceDate.isValid() ? parsedInvoiceDate.format('YYYY-MM-DD') : String(invoiceDateValue).trim(),
				Errors: []
			};
			const serialProductError = getSerialProductError(serialNumber, productType);

			if (serialProductError) {
				addRowError(row, serialProductError);
			}

			if (!parsedInvoiceDate.isValid()) {
				addRowError(row, 'Invoice date is invalid.');
			}

			rows.push(row);
		});
	});

	const rowsBySerial = {};
	rows.forEach(row => {
		if (!row.SerialNumber) return;
		const serialKey = row.SerialNumber.toUpperCase();
		rowsBySerial[serialKey] = rowsBySerial[serialKey] || [];
		rowsBySerial[serialKey].push(row);
	});

	Object.keys(rowsBySerial).forEach(serialKey => {
		const matchingRows = rowsBySerial[serialKey];
		if (matchingRows.length < 2) return;

		const dates = matchingRows.map(row => row.InvoiceDate);
		const hasConflictingDates = dates.some(date => date !== dates[0]);
		matchingRows.forEach(row => addRowError(
			row,
			hasConflictingDates
				? 'Duplicate serial number has conflicting invoice dates.'
				: 'Duplicate serial number.'
		));
	});

	return rows.map(row => ({
		...row,
		IsValid: row.Errors.length === 0,
		Status: row.Errors.length === 0 ? 'Ready' : row.Errors.join(' ')
	}));
};

export const getShipmentDateRequestBody = (rows, productType) => ({
	ProductID: parseInt(productType),
	ShipmentDatesList: (rows || []).map(row => ({
		SerialNumber: row.SerialNumber,
		InvoiceDate: row.InvoiceDate
	}))
});
